import React from 'react';
import { Button } from './Button';
interface Bloque {
  bloque: string;
  contenido: string;
}
interface Module {
  emoji: string;
  title: string;
  meta: string;
  intro: string;
  bloques: Bloque[];
  closing?: string;
}
const MODULES: Module[] = [{
  emoji: '📘',
  title: 'MÓDULO 1 — Evaluación Clínica',
  meta: '90 fichas · 3 rangos etarios · 6 bloques de trabajo',
  intro: 'Lo primero que usás. Lo que define todo el tratamiento.',
  bloques: [{
    bloque: 'Screening inicial',
    contenido: 'Criterios de orientación diagnóstica desde la primera sesión'
  }, {
    bloque: 'Escalas de severidad',
    contenido: 'Medición objetiva del grado de disfluencia'
  }, {
    bloque: 'Observación de bloqueos',
    contenido: 'Registro de tipo frecuencia y contexto'
  }, {
    bloque: 'Entrevistas familiares',
    contenido: 'Estructuradas para niños adolescentes y adultos'
  }, {
    bloque: 'Detección temprana',
    contenido: 'Señales de alarma diferenciadas por edad'
  }, {
    bloque: 'Diferenciación diagnóstica',
    contenido: 'Disfluencia evolutiva vs disfemia patológica'
  }],
  closing: 'Nunca más salís de una primera sesión sin saber exactamente por dónde empezar.'
}, {
  emoji: '📗',
  title: 'MÓDULO 2 — Tartamudez Infantil',
  meta: '90 fichas · Niños de 4 a 11 años · 6 bloques de trabajo',
  intro: 'Para el paciente más frecuente. Y el más difícil de tener material específico.',
  bloques: [{
    bloque: 'Juegos terapéuticos',
    contenido: 'Actividades lúdicas que trabajan la fluencia sin presión'
  }, {
    bloque: 'Inicio suave',
    contenido: 'Secuencias de práctica graduadas por edad'
  }, {
    bloque: 'Modelado',
    contenido: 'Reducción de la presión comunicativa en el entorno'
  }, {
    bloque: 'Actividades por edad',
    contenido: 'Diferenciadas para 4-6 / 7-9 / 10-11 años'
  }, {
    bloque: 'Fluidez en lectura',
    contenido: 'Protocolos para distintos niveles lectores'
  }, {
    bloque: 'Integración',
    contenido: 'Cierre del proceso y sostenibilidad del avance'
  }]
}, {
  emoji: '📙',
  title: 'MÓDULO 3 — Disfemia',
  meta: '90 fichas · 3 rangos etarios · 6 bloques de trabajo',
  intro: 'Para el paciente que sufre. No solo que disfluye.',
  bloques: [{
    bloque: 'Bloqueos tónicos y clónicos',
    contenido: 'Estrategias diferenciadas según el tipo de bloqueo'
  }, {
    bloque: 'Conductas secundarias',
    contenido: 'Identificación registro y trabajo gradual'
  }, {
    bloque: 'Tensión al hablar',
    contenido: 'Protocolo de relajación laríngea y facial'
  }, {
    bloque: 'Afrontamiento',
    contenido: 'Estrategias para situaciones de alta demanda'
  }, {
    bloque: 'Exposición progresiva',
    contenido: 'Jerarquía de situaciones construida con el paciente'
  }, {
    bloque: 'Trabajo emocional',
    contenido: 'Integrado al trabajo técnico en cada sesión'
  }]
}, {
  emoji: '📔',
  title: 'MÓDULO 4 — Disfluencia',
  meta: '90 fichas · 3 rangos etarios · 6 bloques de trabajo',
  intro: 'Las técnicas que funcionan. Organizadas en un sistema progresivo.',
  bloques: [{
    bloque: 'Ritmo del habla',
    contenido: 'Control progresivo de la velocidad'
  }, {
    bloque: 'Respiración abdominal',
    contenido: 'Coordinación con el habla desde el nivel básico'
  }, {
    bloque: 'Coordinación fono-respiratoria',
    contenido: 'Desde el nivel básico hasta el complejo'
  }, {
    bloque: 'Pausas naturales',
    contenido: 'Como herramienta de fluencia y no como interrupción'
  }, {
    bloque: 'Prolongaciones',
    contenido: 'Secuencias de práctica graduadas'
  }, {
    bloque: 'Conciencia del habla',
    contenido: 'Sin hiperconciencia que amplifique la disfluencia'
  }]
}, {
  emoji: '📒',
  title: 'MÓDULO 5 — Adolescentes y Adultos',
  meta: '90 fichas · Adolescentes 12-18 · Adultos 18+ · 6 bloques',
  intro: 'Para cuando la tartamudez ya le costó oportunidades reales.',
  bloques: [{
    bloque: 'Ansiedad social',
    contenido: 'Protocolo de exposición gradual a situaciones comunicativas'
  }, {
    bloque: 'Llamadas telefónicas',
    contenido: 'El miedo más frecuente. Con guiones y práctica progresiva'
  }, {
    bloque: 'Exposición oral',
    contenido: 'En contextos laborales y académicos'
  }, {
    bloque: 'Entrevistas laborales',
    contenido: 'Protocolo completo de preparación y práctica'
  }, {
    bloque: 'Autoestima comunicativa',
    contenido: 'Identidad más allá de la fluencia'
  }, {
    bloque: 'Integración',
    contenido: 'Técnicas en situaciones reales cotidianas'
  }],
  closing: 'El módulo que tus pacientes adultos nunca tuvieron y siempre necesitaron.'
}, {
  emoji: '📓',
  title: 'MÓDULO 6 — Familia y Escuela',
  meta: '90 fichas · Familias + Docentes · 6 bloques',
  intro: 'El sistema no funciona si la vida del paciente no acompaña.',
  bloques: [{
    bloque: 'Qué NO y qué SÍ decir',
    contenido: 'Para familias y docentes con ejemplos concretos'
  }, {
    bloque: 'Cómo acompañar',
    contenido: 'Sin sobreproteger y sin invalidar'
  }, {
    bloque: 'Bullying',
    contenido: 'Detección intervención y prevención'
  }, {
    bloque: 'Validación emocional',
    contenido: 'Protocolos para familias y docentes'
  }, {
    bloque: 'Guía para docentes',
    contenido: 'Lecturas orales exposiciones participación en clase'
  }, {
    bloque: 'Integración',
    contenido: 'Sostenibilidad del tratamiento más allá del consultorio'
  }]
}];
export function Modules() {
  return <section className="flex flex-col gap-8 py-12" data-id="element-69">
      <h3 className="font-serif text-3xl font-bold text-[#0F4C3A] text-center" data-id="element-70">
        Los 6 módulos en detalle
      </h3>

      <div className="flex flex-col gap-8" data-id="element-71">
        {MODULES.map((mod, idx) => <div key={idx} className="flex flex-col bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200 gap-5" data-id="element-72">
            <div className="flex flex-col items-center text-center gap-2" data-id="element-73">
              <span className="text-5xl mb-1" data-id="element-74">{mod.emoji}</span>
              <h4 className="font-serif text-xl md:text-2xl font-bold text-[#0F4C3A]" data-id="element-75">
                {mod.title}
              </h4>
              <p className="text-sm font-bold text-[#D97757] uppercase tracking-wide" data-id="element-76">
                {mod.meta}
              </p>
            </div>

            <p className="text-center text-stone-700 font-medium italic" data-id="element-77">
              {mod.intro}
            </p>

            <div className="flex flex-col gap-2 border-t border-stone-100 pt-5" data-id="element-78">
              {mod.bloques.map((b, bi) => <div key={bi} className="flex flex-col gap-1 py-3 border-b border-stone-100 last:border-b-0" data-id="element-79">
                  <p className="font-bold text-[#0F4C3A] text-sm uppercase tracking-wide" data-id="element-80">
                    {b.bloque}
                  </p>
                  <p className="text-stone-700" data-id="element-81">{b.contenido}</p>
                </div>)}
            </div>

            {mod.closing && <p className="text-center text-stone-800 font-bold pt-2" data-id="element-82">
                {mod.closing}
              </p>}
          </div>)}
      </div>

      <div className="mt-6" data-id="element-83">
        <Button href="#compra" data-id="element-84">SÍ, QUIERO DEJAR DE IMPROVISAR →</Button>
      </div>
    </section>;
}